module.exports = __webpack_public_path__ + "src/img/marleyspoon/feature-small.49ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marleyspoon/feature-small.jpg
// module id = 107
// module chunks = 0